<template>
  <div class="recallMsg">
    <div class="management-search">
      <div class="management-search-1">
        手机号：
        <a-input
          placeholder="请输入手机号"
          v-model="phone"
          allow-clear
        ></a-input>
      </div>
      <div class="management-search-1">
        类型：
        <a-select
          v-model="type"
          placeholder="请选择类型"
          class="select-tag"
          @change="query(1)"
          allow-clear
        >
          <a-select-option
            v-for="item in typeSelectList"
            :key="item.id"
            :value="item.code"
            >{{ item.name }}</a-select-option
          >
        </a-select>
      </div>
      <div class="management-search-1">
        起止时间：
        <a-date-picker
          showTime
          format="YYYY-MM-DD HH:mm:ss"
          v-model="startTime"
          placeholder="开始时间"
        />
        <i style="display: inline-block; margin-left: 20px"></i>
        <a-date-picker
          showTime
          format="YYYY-MM-DD HH:mm:ss"
          placeholder="结束时间"
          v-model="endTime"
        />
      </div>
    </div>
    <div class="management-search">
      <div class="management-search-1">
        <a-checkbox v-model="sendSuccess" @change="query(1)"
          >是否发送成功</a-checkbox
        >
      </div>
      <div class="management-search-1">
        <a-checkbox v-model="click" @change="query(1)">是否点击</a-checkbox>
      </div>
      <div class="management-search-1">
        <a-checkbox v-model="wakeUp" @change="query(1)">是否唤醒</a-checkbox>
      </div>
    </div>
    <div class="projectList-search-button">
      <a-button type="primary" @click="query(1)">查询</a-button>
      <i style="display: inline-block; margin-right: 20px"></i>
      <a-button type="primary" @click="sendMsg">发送短信</a-button>
    </div>
    <a-table
      :columns="tableColumns"
      :dataSource="tableDataSource"
      :pagination="tablePagination"
      :loading="loadingTable"
      size="middle"
      :rowKey="(record) => record.id"
    >
      <span slot="sendSuccess" slot-scope="text, record">
        <a-tag color="green" v-if="text">是</a-tag>
        <a-tag color="red" v-else>否</a-tag>
      </span>
      <span slot="click" slot-scope="text, record">
        <a-tag color="green" v-if="text">是</a-tag>
        <a-tag color="red" v-else>否</a-tag>
      </span>
      <span slot="wakeUp" slot-scope="text, record">
        <a-tag color="green" v-if="text">是</a-tag>
        <a-tag color="red" v-else>否</a-tag>
      </span>
    </a-table>
    <a-modal
      title="发送短信"
      v-model="addKeyVisible"
      :maskClosable="false"
      class="action-class"
      width="680px"
    >
      <a-form>
        <a-form-item
          label="渠道:"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-select
            v-model="typeAdd"
            placeholder="请选择类型"
            class="select-tag"
          >
            <a-select-option
              v-for="item in typeSelectList"
              :key="item.id"
              :value="item.code"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item
          label="起止时间:"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-date-picker
            showTime
            format="YYYY-MM-DD HH:mm:ss"
            v-model="startTimeAdd"
            placeholder="开始时间"
          />
          -
          <a-date-picker
            showTime
            format="YYYY-MM-DD HH:mm:ss"
            placeholder="结束时间"
            v-model="endTimeAdd"
          />
        </a-form-item>
      </a-form>
      <template slot="footer">
        <div style="display: flex; justify-content: center">
          <a-button key="back" @click="addKeyVisible = false">取消</a-button>
          <a-button key="submit" type="primary" @click="sendMsg_submit"
            >确定</a-button
          >
        </div>
      </template>
    </a-modal>
  </div>
</template>
<script>
import api from "../lib/recall.js";
import moment from "moment";

export default {
  name: "recallMsg",
  data() {
    return {
      type: undefined,
      phone: "",
      pageNo: 1,
      tableColumns: [
        {
          title: "编号",
          dataIndex: "id",
          width: 60,
        },
        {
          title: "类型",
          dataIndex: "typeLabel",
          width: 200,
          ellipsis: true,
        },
        {
          title: "手机号",
          dataIndex: "phone",
        },
        {
          title: "是否发送成功",
          dataIndex: "sendSuccess",
          scopedSlots: { customRender: "sendSuccess" },
          width: 100,
          align: "center",
        },
        {
          title: "是否点击",
          dataIndex: "click",
          scopedSlots: { customRender: "click" },
          width: 80,
          align: "center",
        },
        {
          title: "是否唤醒",
          dataIndex: "wakeUp",
          scopedSlots: { customRender: "wakeUp" },
          width: 80,
          align: "center",
        },
        {
          title: "短信内容",
          dataIndex: "msgContent",
          width: 300,
          ellipsis: true,
        },
        {
          title: "创建时间",
          dataIndex: "gmtCreated",
        },
      ],
      tableDataSource: [],
      tablePagination: {},
      loadingTable: false,
      typeSelectList: [],
      startTime: null,
      endTime: null,
      startTimeAdd: null,
      endTimeAdd: null,
      addKeyVisible: false,
      typeAdd: undefined,
      sendSuccess: false,
      click: false,
      wakeUp: false,
    };
  },
  computed: {
    lastLoginDateEndTime() {
      // 开始时间
      if (this.endTime) {
        return this.$common.transformTime(this.endTime);
      }
      return "";
    },
    lastLoginDateStartTime() {
      // 结束时间
      if (this.startTime) {
        return this.$common.transformTime(this.startTime);
      }
      return "";
    },
  },
  mounted() {
    this.today();
    this.getTypeList();
  },
  methods: {
    sendMsg() {
      this.typeAdd = undefined;
      this.startTimeAdd = null;
      this.endTimeAdd = null;
      this.addKeyVisible = true;
    },
    sendMsg_submit() {
      let data = {
        type: this.typeAdd,
      };
      if (this.startTimeAdd) {
        data.startTime = this.$common.transformTime(this.startTimeAdd);
      }
      if (this.endTimeAdd) {
        data.endTime = this.$common.transformTime(this.endTimeAdd);
      }
      api.sendRecallMsg(data).then((res) => {
        if (res.result == 200) {
          this.$message.success("发送成功");
          this.addKeyVisible = false;
          this.query();
        }
      });
    },
    today() {
      let startTime = new Date();
      startTime.setHours(0);
      startTime.setMinutes(0);
      startTime.setSeconds(0);
      startTime.setMilliseconds(0);
      let endTime = new Date();
      endTime.setHours(23);
      endTime.setMinutes(59);
      endTime.setSeconds(59);
      endTime.setMilliseconds(59);
      this.startTime = moment(startTime, "YYYY-MM-DD HH:mm:ss");
      this.endTime = moment(endTime, "YYYY-MM-DD HH:mm:ss");
    },
    getTypeList() {
      api.recallTypeList().then((res) => {
        if (res.result == 200) {
          this.typeSelectList = res.data;
          this.query(1);
        }
      });
    },
    // 点击查询
    query(index) {
      if (index) {
        this.pageNo = index;
      }
      let data = {
        type: this.type,
        phone: this.phone,
        pageSize: 10,
        pageNo: this.pageNo,
        startTime: this.lastLoginDateStartTime,
        endTime: this.lastLoginDateEndTime,
      };
      if (this.click) {
        data.click = this.click;
      }
      if (this.sendSuccess) {
        data.sendSuccess = this.sendSuccess;
      }
      if (this.wakeUp) {
        data.wakeUp = this.wakeUp;
      }
      this.queryPage(data);
    },
    // 查询列表
    queryPage(data) {
      this.loadingTable = true;
      api
        .recallMsgPage(data)
        .then((res) => {
          this.loadingTable = false;
          if (res.result === 200) {
            this.tableDataSource = res.data.records;
            this.tableDataSource.forEach((item) => {
              this.typeSelectList.forEach((type) => {
                if (item.type == type.code) {
                  this.$set(item, "typeLabel", type.name);
                }
              });
            });
            this.tablePagination = {
              showQuickJumper: true,
              showTotal: () => `共${res.data.total}条`,
              pageSize: data.pageSize,
              current: data.pageNo,
              total: res.data.total,
              onChange: (current) => this.changePageItem(current),
            };
          }
        })
        .catch((err) => {
          this.loadingTable = false;
        });
    },
    changePageItem(index) {
      this.query(index);
    },
  },
};
</script>
<style lang="scss" scoped>
.recallMsg {
  .management-search {
    position: relative;
    overflow: hidden;
    .management-search-1 {
      float: left;
      margin-right: 20px;
      margin-bottom: 20px;
    }
    .backup {
      padding: 5px 0;
    }
    span {
      width: 240px;
    }
    input {
      width: 240px;
    }
    .ant-select {
      width: 240px;
    }
  }
  .projectList-search-button {
    margin-bottom: 20px;
    button {
      margin-right: 20px;
    }
    .request_nav_item {
      display: inline-block;
      margin-right: 20px;
      width: 350px;
      input {
        width: 250px;
      }
      .ant-select {
        width: 250px;
      }
    }
  }
}
</style>
